var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHybrid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 28,
    viewBox: "0 0 44 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.98984 18H2.99143L3.98984 11H0.495416C-0.0836591 11 -0.0736751 10.68 0.116022 10.34C0.305719 10 0.165942 10.26 0.185911 10.22C1.47385 7.94 3.41076 4.54 5.98665 0H6.98506L5.98665 7H9.48107C9.97029 7 10.0402 7.33 9.95032 7.51L9.88043 7.66C5.94671 14.55 3.98984 18 3.98984 18Z",
    fill: "#FDA536"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4844 4.5V13.5",
    stroke: "black",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9844 9L13.9844 9",
    stroke: "black",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7292 4.23L42.7392 4.22L39.0252 0.5L37.9668 1.56L40.0735 3.67C39.135 4.03 38.466 4.93 38.466 6C38.466 7.38 39.5843 8.5 40.9621 8.5C41.3215 8.5 41.651 8.42 41.9605 8.29V15.5C41.9605 16.05 41.5112 16.5 40.9621 16.5C40.4129 16.5 39.9637 16.05 39.9637 15.5V11C39.9637 9.9 39.0651 9 37.9668 9H36.9684V2C36.9684 0.9 36.0699 0 34.9716 0H28.9812C27.8829 0 26.9844 0.9 26.9844 2V18H36.9684V10.5H38.466V15.5C38.466 16.88 39.5843 18 40.9621 18C42.3399 18 43.4581 16.88 43.4581 15.5V6C43.4581 5.31 43.1785 4.68 42.7292 4.23ZM34.9716 7H28.9812V2H34.9716V7ZM40.9621 7C40.4129 7 39.9637 6.55 39.9637 6C39.9637 5.45 40.4129 5 40.9621 5C41.5112 5 41.9605 5.45 41.9605 6C41.9605 6.55 41.5112 7 40.9621 7Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHybrid);
export default __webpack_public_path__ + "static/media/icon-hybrid.e051864f74722cd35794990b5c7ebb98.svg";
export { ForwardRef as ReactComponent };